import { request } from "./request"

export default {
  /**
   * 销售员关系信息
   * @param {String} SalesmanCode 销售员Code
   * @returns 
   */
  getSalesGroupBySalesman (SalesmanCode) {
    return request({
      url: "/Optional/getSalesGroupBySalesman",
      method: "get",
      params: {
        SalesmanCode
      }
    })
  },
  /**
   * 客户选项
   * @param {String} Keyword 关键字
   */
  getCustomersOptionsByKeyword (Keyword) {
    return request({
      url: "/Optional/getCustomersOptionsByKeyword",
      method: "get",
      params: {
        Keyword
      }
    })
  },
  /**
   * 客户选项(Advertiser)
   */
  getAdvertiserOptions () {
    return request({
      url: "/Optional/getAdvertiserOptions",
      method: "get",
    })
  },
  /**
   * 客户选项(Agency)
   */
  getAgencyOptions () {
    return request({
      url: "/Optional/getAgencyOptions",
      method: "get",
    })
  },
  /**
  * 客户选项
  */
  getClientTypeOptionals () {
    return request({
      url: "/Optional/getClientTypeOptionals",
      method: "get",
      params: {
      }
    })
  },
  /**
  * 代理选项
  */
  getAgencyTypeOptionals () {
    return request({
      url: "/Optional/getAgencyTypeOptionals",
      method: "get",
      params: {
      }
    })
  },
  /**
   * 客户行业分类选项
   */
  getCustomerBusinessOptionals (CustomerCode) {
    return request({
      url: "/Optional/getBussinessCategoryOptionalsByCustomer",
      method: "get",
      params: {
        CustomerCode
      }
    })
  },
  /**
   * 订单状态选项
   */
  getOrderStatusOptionals () {
    return request({
      url: "/Optional/getOrderStatusOptionals",
      method: "get",
      params: {

      }
    })
  },
  /**
   * 合同类型选项
   */
  getContractTypeOptionals () {
    return request({
      url: "/Optional/getContractTypeOptinals",
      method: "get",
      params: {

      }
    })
  },
  /**
   * 生产合同预定选项组
   */
  getProductionBookingTypeOptionals () {
    return request({
      url: "/optional/getProductionBookingTypeOptionals",
      method: "get"
    })
  },
  /**
   * 媒体合同类型
   */
  getMediaContractTypeOptionals () {
    return request({
      url: "/Optional/getMediaContractTypeOptionals",
      method: "get",
      params: {

      }
    })
  },
  /**
   * 生产合同类型
   * @returns 
   */
  getProductionContractTypeOptionals () {
    return request({
      url: "/Optional/getProductionContractTypeOptionals",
      method: "get",
      params: {

      }
    })
  },
  /**
   * 生产合同类型联级
   * @param {*} OptionalKey 
   * @returns 
   */
  getNextProductionContractTypeOptionals (OptionalKey) {
    return request({
      url: "/Optional/getNextProductionContractTypeOptionals",
      method: "get",
      params: {
        OptionalKey
      }
    })
  },
  /**
   * 生产成本类型选项
   */
  getProductionCostOptionals () {
    return request({
      url: "/Optional/getProductionCostOptionals",
      method: "get",
      params: {

      }
    })
  },
  /**
  * 销售服务费用选项
  */
  getSalesServiceFeeOptionals () {
    return request({
      url: "/Optional/getSalesServiceFeeOptionals",
      method: "get",
      params: {

      }
    })
  },
  /**
   * Product Category选项
   * @param {String} CustomerCode 客户编号
   * @returns 
   */
  getCustomerProductiCategories (CustomerCode) {
    return request({
      url: "/Optional/getCustomerProductiCategories",
      method: "get",
      params: {
        CustomerCode
      }
    })
  },
  /**
   * 单据选项
   * @param {String} CustomerCode 
   * @returns 
   */
  getCustomerBillNames (CustomerCode) {
    return request({
      url: "/optional/getCustomerBillNames",
      method: 'get',
      params: {
        CustomerCode
      }
    })
  },
  getBasicOptionals (OptionalKey) {
    return request({
      url: "/Optional/getBasicOptionals",
      method: "get",
      params: {
        OptionalKey
      }
    })
  },
  /**
   * 付款期限选项
   */
  getPaymentTerm () {
    return request({
      url: "/Optional/getPaymentTerm",
      method: "get",
    })
  },
  /**
   * 发票期限选项
   */
  getInvoiceTerm () {
    return request({
      url: "/Optional/getInvoiceTerm",
      method: "get",
    })
  },
  /**
   * 合同付款时间选项
   * @returns 
   */
  getContractPaymentScheduleOptions (BusinessNature) {
    return request({
      url: "/Optional/getContractPaymentScheduleOptions",
      method: "get",
      params: {
        BusinessNature
      }
    })
  },
  /**
  * 获取ContractingParty的数据
  * @param {String} lang 
  * @returns 
  */
  getContractingPartyData (lang) {
    return request({
      url: "/Optional/GetContractingPartyData",
      method: "get",
      params: {
        lang
      }
    })
  },
  /**
* 获取ContractingParty的数据
* @param {Object} data 
* @returns 
*/
  getBusinessCategoriesList (data) {
    return request({
      url: "/Optional/GetBusinessCategoriesList",
      method: "get",
      params: data
    })
  },
  /**
* 获取ContractingParty的数据
* @param {Object} data 
* @returns 
*/
  getBillNameOptinals (data) {
    return request({
      url: "/Optional/GetBillNameOptinals",
      method: "get",
      params: data
    })
  },
  /**
* 根据公司ID获取代理客户
* @param {Object} data 
* @returns 
*/
  getAgencyListByAdvertiserId (data) {
    return request({
      url: "/Optional/GetAgencyListByAdvertiserId",
      method: "get",
      params: data
    })
  },
  /**
* 获取media Append 下拉数据BusShelter
* @returns 
*/
  getBusShelterLocationOptions () {
    return request({
      url: "/Optional/getBusShelterLocationOptions",
      method: "get"
    })
  },
  /**
  * 获取AG/DC list
  * @param {String} lang 
  * @returns 
  */
  getContractingPartyList (lang) {
    return request({
      url: "/Optional/GetContractingPartyList",
      method: "get",
      params: {
        lang
      }
    })
  },
  /**
   * Change Action Options
   * @returns 
   */
  getChangeActionOptionals () {
    return request({
      url: "/Optional/getChangeActionOptionals",
      method: "get",
    })
  },
}
